import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { queryClient } from 'providers';

import { TransectionApiServices } from '../api/transection-api.service';

const { UpdaterefundpostponedetailsStatus } = TransectionApiServices();

export const useUpdatePostPondRefund = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return UpdaterefundpostponedetailsStatus(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                message.success("Update successfully!!");
            },
        },
    );
};